import '@utils/development'

import Vue from 'vue'
import 'babel-polyfill'

import App from './App'
import router from '@router'
import i18n from '@lang'
import store from '@store'

import '@components/_globals'
import '@directive'
import '@plugins'
import '@src/mock'
import '@styles/index.jtails.scss'
import '@plugins/fontawesome'

Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.prototype.$bus = new Vue();

Promise.all([
  store.dispatch('auth/init'),
  store.dispatch('merchant/init')
])
  .then(() => {
    new Vue({
      i18n,
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  });
